module.exports = __webpack_public_path__ + "media/registration/trans-icon-6c34d3c7.svg";